import styled from 'styled-components'
import { colorscale } from 'components/MainComponent/MainComponent'

const steps = [3, 4, 5, 6, 7, 8, 9, 10]

export const TimeSelect = ({
  onChange,
  current,
  isMobile = false,
  isFullscreen = false,
  locales
}: {
  onChange: (e: number) => void
  current: number
  isMobile?: boolean
  isFullscreen?: boolean
  locales:{label:string}
}) => {
  return (
    <TimeSelectRoot
      className='TimeSelectRoot'
      isMobile={isMobile}
      isFullscreen={isFullscreen}
    >
      <TimeLabel>{locales.label}</TimeLabel>
      {steps.map((step, i) => {
        return (
          <button
            style={{
              backgroundColor: step > current ? '#f0f0f0' : colorscale(step),
              color: step > current ? '#eee' : 'var(--brandblue-main)',

              // border:
              //   current === step ? '2px solid var(--text-color)' : undefined,
            }}
            onClick={() => onChange(step)}
          >
            {step}h
          </button>
        )
      })}
    </TimeSelectRoot>
  )
}

const TimeLabel = styled.div`
  font-size: 15px;
  opacity: 0.75;
  flex: 0 0 100%;
`

const TimeSelectRoot = styled.div<{ isMobile: boolean; isFullscreen: boolean }>`
  pointer-events: all;
  flex-wrap: wrap;
  position: relative;
  top: ${(props) => (props.isMobile ? '0px' : '0')};
  padding-bottom: 40px;
  z-index: 100;
  max-width: 350px;
  display: flex;
  margin-bottom: 15px;
  background-color: var(--site-background);
  padding: 10px;

  &:hover {
    cursor: pointer;
  }
  button {
    padding: 5px 0px;
    flex: 0 0 calc(calc(100% / 8) - 5px);
    text-align: center;
    border: 0;
    margin-right: 2px;
    border: 1px solid var(--site-background);
    color: var(--brandblue-main) !important;
    &:hover {
      border: 1px solid var(--text-color);
      cursor: pointer !important;
    }
  }

  /* @media screen and (max-width: 711px) {
    padding-left: 10px;
   
    button {
      padding: 5px 5px;
      width: calc(calc(100% / 8) - 2px);
    }
  } */
  @media screen and (max-width: 711px) {
    margin-left: ${(props) => (props.isFullscreen ? '20px' : '0')};
    max-width: ${(props) =>
      props.isFullscreen ? 'calc(100% - 90px)' : '100%'};
    padding-top: 0px;

    button {
      padding: 5px 5px;
      width: calc(calc(100% / 8) - 0px);
    }
  }
`
